import React from "react";
import { Link } from "react-router-dom";
import MainButton from "../../components/Elements/MainButton/MainButton";
import emptyImg from "../../assets/cart/cart-gray.png";
import "./Cart.css";

const EmptyCartView = () => (
  <div className="cart-container">
    <section className="empty-cart">
      <img src={emptyImg} alt="" aria-hidden="true" className="empty-cart__img" />
      <h2 className="empty-cart__title">Your Cart is Empty</h2>
      <p className="empty-cart__lead">
        You haven't added any eSIM packages yet. Start exploring our plans to get connected!
      </p>
      <Link to="/shop" className="empty-cart__cta">
        <MainButton type="button">Browse our eSIM Packages</MainButton>
      </Link>
    </section>
  </div>
);

export default EmptyCartView;
